export enum SortRating{
  Latest = "Latest",
  HighestRating = "Highest",
  LowestRating = "Lowest",
  Undefined = 'Undefined'
}
